import { MenuItem, Tab, TabPane } from "semantic-ui-react";
import { NewPeoplePage } from "./NewPeoplePage";
import { NewOrganizationsPage } from "./NewOrganizationsPage";

export const SocialNetwork = () => {
  const panes = [
    {
      menuItem: <MenuItem>People</MenuItem>,
      render: () => (
        <TabPane attached={false}>
          <NewPeoplePage />
        </TabPane>
      ),
    },
    {
      menuItem: <MenuItem>Organizations</MenuItem>,
      render: () => (
        <TabPane attached={false}>
          <NewOrganizationsPage />
        </TabPane>
      ),
    },
  ];

  return <Tab menu={{ secondary: true, pointing: true }} panes={panes} />;
};
